<template>
  <Table :headers="['Plano de aula', 'Horas exigidas', 'Horas cumpridas', 'Horas necessárias']">
    <tr v-for="categoria in cargaHoraria" :key="categoria.id">
      <td>{{ categoria.titulo }}</td>
      <td>{{ Math.max(0, Math.round(categoria.exigido / 50)) }}</td>
      <td>{{ Math.max(0, Math.round(categoria.realizado / 50)) }}</td>
      <td>{{ Math.max(0, Math.round((categoria.exigido - categoria.realizado) / 50)) }}</td>
    </tr>
  </Table>
</template>

<script>
import Table from '../core/Table'

export default {
  name: 'carga-horaria-teorica-table',
  components: {
    Table,
  },
  props: {
    cargaHoraria: {
      type: Array,
      required: true,
    }
  },
}
</script>
